import React, { useEffect, useState } from "react";
import FilterSelector from "../Components/FilterSelector";

import { AgCharts } from "ag-charts-react";

function InvestmentToIncome({ data }) {
  const [activeDuration, setActiveDuration] = useState("overall_summary");
  const [barGraph, setBarGraph] = useState([]);
  const [series, setSeries] = useState([]);
  const [scoreData, setScoreData] = useState({
    score: 0,
    status: "",
  });
  const getColor = (remark) => {
    switch (remark) {
      case "Critical":
      case "Low":
        return "#d30d00";
      case "Medium":
        return "#f7a452";
      case "High":
        return "#00960f";
      default:
        return "#f7a452";
    }
  };
  function formatToIndianRupees(num) {
    // Convert the number to a string
    if (num === null || num === undefined) return "₹--";
    return num.toLocaleString("en-IN", {
      maximumFractionDigits: 0,
      style: "currency",
      currency: "INR",
    });
  }

  const [options, setOptions] = useState({
    data: barGraph,
    series: series,
    legend: {
      item: {
        label: {
          fontSize: 11, // Change the legend font size

          fontWeight: "normal",
          color: "#637381", // Change the legend font color
        },
        marker: {
          size: 11, // Change the size of the color boxes
        },
      },
    },

    axes: [
      {
        type: "category",
        position: "bottom",
        gridLine: false,
        label: {
          fontSize: 9,
          fontWeight: "light",
        },
      },
      {
        type: "number",
        position: "left",
        label: {
          fontWeight: "normal",
          fontSize: 11,
          formatter: (params) => {
            // Format with thousand separators and add a currency symbol
            return `${formatToIndianRupees(params.value)}`;
          },
        },
        gridLine: false,
      },
    ],
    barPadding: 0.1, // Default is 0.1, lower this value to reduce bar width
    groupPadding: 0.1,
    height: 340,
  });

  function indianNumberFormat(num) {
    if (num >= 1e7) {
      num = num / 1e7;
      return `${num.toFixed(2)} Cr`;
    } else if (num >= 1e5) {
      num = num / 1e5;
      return `${num.toFixed(3)} L`;
    } else if (num >= 1e3) {
      num = num / 1e3;
      return `${num.toFixed(2)} K`;
    }
    return num.toFixed(2).toString();
    // return num.toString();
  }
  const mapDataBarGraph = (data, lineArray) => {
    const array = Object.keys(data).map((key, index) => {
      const quarter = key;
      const main = data[key];
      const subObject = Object.keys(main).reduce((acc, subkey) => {
        acc[subkey] = main[subkey]; // Set the value to the second element
        return acc;
      }, {});
      return {
        quarter: quarter,
        ...subObject,
        income: lineArray[index],
      };
    });

    return array;
  };
  const baseColors = [
    "#e8787d",
    "#26aba4",
    "#9d53f2",
    "#66a9e4",
    "#f7a452",
    "#beb9db",
    "#87bc45",
    "#27aeef",
    "#ffee65",
  ];
  const mapSeries = (data) => {
    const array = data.map((item, index) => {
      return {
        type: "bar",
        xKey: "quarter",
        yKey: item,
        yName: item,
        cornerRadius: 10,
        fill: baseColors[index % baseColors.length],
        stacked: true,
      };
    });
    array.push({
      type: "line",
      xKey: "quarter",
      yKey: "income",
      yName: "Income (Monthly)",
      stroke: "#0070d2",
      strokeWidth: 2,
      lineDash: [6, 3],
      marker: { enabled: false },
    });

    return array;
  };
  useEffect(() => {
    setBarGraph(
      mapDataBarGraph(
        data
          ? data[activeDuration]["investment_to_income_%"].investment_categories
          : {},
        data
          ? data[activeDuration]["investment_to_income_%"].income_data["y-axis"]
          : []
      )
    );
    setSeries(
      mapSeries(
        data ? data[activeDuration]["investment_to_income_%"]?.legend_array : []
      )
    );
    if (data) {
      setScoreData({
        score:
          data[activeDuration]["investment_to_income_%"]
            .overall_investment_income_ratio,
        status: data[activeDuration]["investment_to_income_%"].remark,
      });
    }
  }, [activeDuration, data]);
  useEffect(() => {
    setOptions({ ...options, data: barGraph, series: series });
  }, [barGraph, series]);

  return (
    <div className=" w-[49.5%] border border-[#e6ebed] rounded-lg ">
      <div className=" rounded-t-lg bg-[#f3f3f3] py-3 px-4 text-[#212b36] font-bold">
        <p>Investment to Income Ratio</p>
      </div>
      <FilterSelector
        activeDuration={activeDuration}
        setActiveDuration={setActiveDuration}
      />
      <div className=" mt-[54px] mb-6 flex flex-col items-center">
        <p className=" text-[#262626] text-[32px] font-bold">
          {scoreData.score}
        </p>
        <p className=" text-xs font-medium text-[#262626] mt-[6px]">
          Investment to Income Ratio is{" "}
          <span
            className=" font-bold "
            style={{
              color: getColor(scoreData.status),
            }}
          >
            {scoreData.status}
          </span>{" "}
        </p>
      </div>
      <div className=" overflow-x-auto mt-[56px] ">
        <p className="text-[#212b36] text-xs font-bold ml-[15.75px]">
          Investment Categorization
        </p>
        <div className="mt-1 ">
          <AgCharts options={options} />{" "}
        </div>
      </div>
    </div>
  );
}

export default InvestmentToIncome;
